// extracted by mini-css-extract-plugin
export default {"cancel":"EditBtn_cancel__jKjEA","edit":"EditBtn_edit__VbIG3","complete":"EditBtn_complete__24GkU"};